// ======================================================================
// File Name       : ServiceNoticeConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { reduxForm, isInvalid, getFormValues } from 'redux-form';
import { Form, Button, Col } from 'react-bootstrap';
import { MODE, DEFAULT_DATE_SHORT_FORMAT_SERVER } from '../../constants/index';
import * as ServiceAction from '../../actions/ServiceAction';
import { SERVICE_NOTIFICATION_LIST } from '../../constants/PathConstants';
import Header from '../../components/Header';
import ModalWrapper from '../../components/modal/ModalWrapper';
import ServiceNoticeDetailInfo from '../../components/service/serviceNotification/ServiceNoticeDetailInfo';
import ServiceNoticeDetailUserList from '../../components/service/serviceNotification/ServiceNoticeDetailUserList';
import { RELEASE_TARGET } from '../../constants/ServiceConstant';
import { MAX_DATE, MIN_DATE } from '../../utils/index';

class ServiceNoticeConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.createParam = this.createParam.bind(this);
    this.registerEditServiceNotice = this.registerEditServiceNotice.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
  }

  registerEditServiceNotice() {
    const { invalid, formValues } = this.props;
    if (invalid || !formValues) {
      return;
    }
    const param = this.createParam(formValues);
    const { dispatch, history } = this.props;
    dispatch(this.props.hideModal());
    dispatch(ServiceAction.registerServiceNotification(param)).then((error) => {
      if (!error) {
        history.push(SERVICE_NOTIFICATION_LIST);
      }
    });
  }

  createParam(formValues) {
    const param = {};
    param.editType = MODE.NEW_MODE;
    const noticeInfo = {};
    noticeInfo.noticeTitle = formValues.noticeTitle;
    noticeInfo.noticeContent = formValues.noticeContent;
    noticeInfo.userType = formValues.userType;
    if (formValues.releasePeriod) {
      formValues.publicDateFrom ?
        (noticeInfo.publicDateFrom = moment(formValues.publicDateFrom).format(DEFAULT_DATE_SHORT_FORMAT_SERVER)) : (noticeInfo.publicDateFrom = MIN_DATE.format(DEFAULT_DATE_SHORT_FORMAT_SERVER));
      formValues.publicDateTo ?
        (noticeInfo.publicDateTo = moment(formValues.publicDateTo).format(DEFAULT_DATE_SHORT_FORMAT_SERVER)) : (noticeInfo.publicDateTo = MAX_DATE.format(DEFAULT_DATE_SHORT_FORMAT_SERVER));
    } else {
      noticeInfo.publicDateFrom = MIN_DATE.format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
      noticeInfo.publicDateTo = MAX_DATE.format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
    }

    noticeInfo.releaseTarget = formValues.releaseTarget;
    if (formValues.releaseTarget === RELEASE_TARGET.INDIVIDUAL) {
      formValues.edittingUserList &&
        (noticeInfo.userList = Object.keys(formValues.edittingUserList));
    }
    if (this.props.isEdit) {
      param.editType = MODE.EDIT_MODE;
      noticeInfo.noticeSecernId = formValues.noticeSecernId;
    }
    param.noticeInfo = noticeInfo;
    return param;
  }

  getModalOptions() {
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
        {
          name: 'OK',
          onClick: this.registerEditServiceNotice,
          variant: 'primary',
        },
      ],
    };
  }

  render() {
    const { formValues, edittingUsers } = this.props;
    let serviceDetailUserList = [];
    let releaseTarget = RELEASE_TARGET.ALL;
    if (formValues && formValues.releaseTarget) {
      releaseTarget = formValues.releaseTarget;
    }
    if (edittingUsers && edittingUsers.allSecernIds && edittingUsers.allSecernIds.length) {
      serviceDetailUserList = edittingUsers.allSecernIds.reduce((acc, cur) => {
        if (cur && edittingUsers.bySecernIds && edittingUsers.bySecernIds[cur]) {
          acc.push(edittingUsers.bySecernIds[cur]);
        }
        return acc;
      }, []);
    }
    return (
      <ModalWrapper temporaryHide={''} {...this.getModalOptions()} hideModal={this.props.hideModal} title="以下の内容で登録します" fixedHeight={false}>
        <div>
          <ServiceNoticeDetailInfo {...formValues} />
          {releaseTarget === RELEASE_TARGET.INDIVIDUAL && (
            <ServiceNoticeDetailUserList serviceDetailUserList={serviceDetailUserList} />
          )}
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  storedUserList: state.service.storedUserList,
  edittingUsers: state.service.edittingUsers,
  formValues: getFormValues('serviceNoticeRegisterForm')(state),
});

export default connect(mapStateToProps)(ServiceNoticeConfirmDialog);
